import ApiService from '../../../../../services/ApiService'
import AboutUnidade from '../aboutUnidade/AboutUnidade.vue'
import ManageUnidade from '../manageUnidade/ManageUnidade.vue'

export default {
  data: () => ({
    activeDialog: false,
    visible: false,
    totalItensOnPage: 0,
    dialog: false,
    editDialog: false,
    aboutDialog: false,
    deleteDialog: false,
    dialogKey: false,
    loading: false,
    unidadeLoading: false,
    institutionLoading: false,
    expanded: [],
    filterUnidades: [],
    institutionId: 0,
    institutions: [],
    unidades: [],
    currentUnidade: {},
    userLogged: {},
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      Name: null,
      Initials: null,
      Cnpj: null,
      institutionId: 0,
      status: 0,
    },
    statusList: [
      { name: 'Ativo', value: 0 },
      { name: 'Inativo', value: 1 },
    ],
    unidadeName: null,
    unidadeInitials: null,
    unidadeCnpj: null,
    error: false,
    show: false,
    message: '',
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
      },
      {
        text: 'Unidade',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
      },
      {
        text: 'Sigla',
        align: 'center',

        value: 'initials',
      },
      {
        text: 'CNPJ',
        align: 'center',

        value: 'cnpj',
      },
      {
        text: 'Cidade',
        align: 'center',

        value: 'city',
      },
      {
        text: 'Telefone',

        value: 'phone',
        align: 'center',
      },
      {
        text: 'Opera aos finais de semana',
        align: 'center',
        value: 'worksOnWeekends',
      },
      {
        text: 'Ações',

        value: 'actions',
        sortable: false,
        width: 200,
      },
    ],
    headersMobile: [
      {
        text: 'Unidade',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Ações',

        value: 'actions',
        sortable: false,
      },
    ],
    institution: {},
    headerProps: {
      sortByText: 'Ordenar por',
    },
  }),

  async created() {
    this.getInstitutions()
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    // if (this.institution.userType == 2) {
    //   this.institutionId = this.userLogged.institutionId
    // }

    this.updateTable()
  },

  components: {
    ManageUnidade,
    AboutUnidade,
  },

  methods: {
    normalizeDayOfWeek(day) {
      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
      }

      if (typeof day === 'number') {
        return day
      }

      if (typeof day === 'string') {
        const parsed = Number(day)
        if (!Number.isNaN(parsed)) {
          return parsed
        }

        return dayMap[day]
      }

      return undefined
    },

    hasActiveWeekend(workHours) {
      if (!Array.isArray(workHours) || workHours.length === 0) {
        return false
      }

      const activeDays = new Set()

      workHours.forEach((workHour) => {
        if (!Array.isArray(workHour.officeWeekDays) || workHour.officeWeekDays.length === 0) {
          return
        }

        workHour.officeWeekDays.forEach((day) => {
          const normalizedDay = this.normalizeDayOfWeek(day)
          if (normalizedDay !== undefined) {
            activeDays.add(normalizedDay)
          }
        })
      })

      return activeDays.has(6) && activeDays.has(0)
    },

    async enrichUnidadesWeekendFlag(unidades) {
      const unidadeList = Array.isArray(unidades) ? unidades : []

      const unidadesWithWeekendFlag = await Promise.all(
        unidadeList.map(async (unidade) => {
          try {
            const response = await this.apiService.get(`UnitWorkHours/list/${unidade.id}`)
            const workHours = response?.statusCode === 200 ? response.content : []

            return {
              ...unidade,
              worksOnWeekends: this.hasActiveWeekend(workHours),
            }
          } catch (error) {
            return {
              ...unidade,
              worksOnWeekends: false,
            }
          }
        })
      )

      return unidadesWithWeekendFlag
    },

    addUnidade() {
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    editUnidade(unidade) {
      this.currentUnidade = unidade
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },

    deleteUnidade(unidade) {
      this.currentUnidade = unidade

      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    activeUnidade(unidade) {
      this.currentUnidade = unidade
      this.dialogKey = !this.dialogKey
      this.activeDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.aboutDialog = false

      this.updateTable()
    },

    openAbout(unidade) {
      this.currentUnidade = unidade
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.Name = this.unidadeName
      this.filter.Initials = this.unidadeInitials
      this.filter.Cnpj = this.unidadeCnpj

      this.updateTable()
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async updateTable() {
      this.loading = true
      this.filter.institutionId = this.institutionId

      await this.apiService
        .post('unidade/list', this.filter)
        .then(async (response) => {
          this.totalPages = response.content.pager.totalPages
          this.unidades = await this.enrichUnidadesWeekendFlag(response.content.unidades)

          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.unidades.length
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    async editStatus() {
      this.loading = true
      if (this.currentUnidade.status == 1) {
        this.currentUnidade.status = 0
      } else {
        this.currentUnidade.status = 1
      }
      await this.apiService
        .post('unidade/edit', this.currentUnidade)
        .then(() => {
          this.loading = false
          this.dialogKey = !this.dialogKey
          this.deleteDialog = false
          this.activeDialog = false
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          this.loading = false
        })
    },

    reset() {
      this.unidadeName = null
      this.unidadeInitials = null
      this.unidadeCnpj = null
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        Name: null,
        Initials: null,
        Cnpj: null,
      }
      this.updateTable()
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },
  },
}
